'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _UICheckbox = require('UIComponents/input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _Functions = require('UIComponents/core/Functions');

var _LegalConsent = require('FormsCommonComponents/constants/LegalConsent');

var _LegalConsent2 = require('FormsCommonComponents/lib/LegalConsent');

var _LegalConsent3 = _interopRequireDefault(_LegalConsent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LegalConsentFields = function (_Component) {
  _inherits(LegalConsentFields, _Component);

  _createClass(LegalConsentFields, null, [{
    key: 'propTypes',
    get: function get() {
      return {
        legalConsentRecord: _react.PropTypes.instanceOf(_LegalConsent3.default).isRequired,
        communicationConsentCheckedState: _react.PropTypes.array,
        onCommunicationCheckboxChange: _react.PropTypes.func
      };
    }
  }]);

  function LegalConsentFields() {
    _classCallCheck(this, LegalConsentFields);

    var _this = _possibleConstructorReturn(this, (LegalConsentFields.__proto__ || Object.getPrototypeOf(LegalConsentFields)).call(this));

    _this.handleCheckboxChange = _this.handleCheckboxChange.bind(_this);
    return _this;
  }

  _createClass(LegalConsentFields, [{
    key: 'handleCheckboxChange',
    value: function handleCheckboxChange(checkbox, checked, isCommunicationConsent) {
      var onCommunicationCheckboxChange = this.props.onCommunicationCheckboxChange;

      if (!isCommunicationConsent) {
        return;
      }

      (0, _Functions.callIfPossible)(onCommunicationCheckboxChange, checkbox, checked);
    }
  }, {
    key: 'renderHelpText',
    value: function renderHelpText(helpText) {
      if (!helpText) {
        return null;
      }
      return _react2.default.createElement(
        _Small2.default,
        { use: 'help' },
        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: helpText } })
      );
    }
  }, {
    key: 'renderCheckbox',
    value: function renderCheckbox(name, label, helpText) {
      var _this2 = this;

      var isCommunicationConsent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var checkbox = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var communicationConsentCheckedState = this.props.communicationConsentCheckedState;

      var isChecked = false;

      if (isCommunicationConsent) {
        var currentCheckbox = (0, _underscore.findWhere)(communicationConsentCheckedState, { communicationTypeId: checkbox.communicationTypeId });
        if (!(0, _underscore.isEmpty)(currentCheckbox)) {
          isChecked = currentCheckbox.consented;
        }
      }
      var requiredStyle = { 'color': "red", 'padding-left': '4px' };

      return _react2.default.createElement(
        'div',
        { key: name },
        _react2.default.createElement(
          _UICheckbox2.default,
          {
            type: 'checkbox',
            name: name,
            size: 'small',
            defaultChecked: isChecked,
            onChange: function onChange(_ref) {
              var checked = _ref.target.checked;
              return _this2.handleCheckboxChange(checkbox, checked, isCommunicationConsent);
            }
          },
          _react2.default.createElement(
            'div',
            { style: { 'display': "flex" } },
            _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: label } }),
            checkbox.required ? _react2.default.createElement(
              'span',
              { style: requiredStyle },
              '*'
            ) : null
          ),
          this.renderHelpText(helpText)
        )
      );
    }
  }, {
    key: 'renderText',
    value: function renderText(name, text) {
      return _react2.default.createElement('p', {
        key: name,
        dangerouslySetInnerHTML: { __html: text }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var legalConsentRecord = this.props.legalConsentRecord;

      return _react2.default.createElement(
        'div',
        { className: 'legal-consent-container' },
        (0, _underscore.values)((0, _LegalConsent2.getEditableLegalConsentKeysForLegalConsentType)(legalConsentRecord.getLegalConsentType())).map(function (key) {
          switch (key) {
            case _LegalConsent.EditableLegalConsentKeys.COMMUNICATION_CONSENT_TEXT:
            case _LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_TEXT:
            case _LegalConsent.EditableLegalConsentKeys.PRIVACY_POLICY_TEXT:
              return _this3.renderText(key, legalConsentRecord.get(key));
            case _LegalConsent.EditableLegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES:
              return legalConsentRecord.get(key).map(function (checkbox) {
                return _this3.renderCheckbox('LEGAL_CONSENT.subscription_type_' + checkbox.communicationTypeId, checkbox.label, null, true, checkbox);
              });
            case _LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL:
              return _this3.renderCheckbox(key, legalConsentRecord.get(key), legalConsentRecord.get(_LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_FOOTER_TEXT));
            default:
              return null;
          }
        })
      );
    }
  }]);

  return LegalConsentFields;
}(_react.Component);

exports.default = LegalConsentFields;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/FormsCommonComponents/static-1.726/js/LegalConsentFields.js
// module id = 489
// module chunks = 0